// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"622044cc","462":"f4549428","693":"2683cc6d","983":"7d5acf3e"}[chunkId] + ".chunk.js";
};